import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    number: '01',
    icon: '\uD83D\uDD0D',
    title: 'Search',
    description: 'Browse our verified specialists and filter by the type of care you need.',
  },
  {
    number: '02',
    icon: '\uD83D\uDCC5',
    title: 'Book',
    description: 'Choose your preferred date and time and share your contact details. No account required.',
  },
  {
    number: '03',
    icon: '\u2705',
    title: 'Confirm',
    description: 'We send your invoice via WhatsApp and email. Once confirmed, your appointment is locked in.',
  },
];

const HowItWorks = () => (
  <section className="how-it-works">
    <div className="container">
      <div className="how-it-works__header">
        <p className="how-it-works__label">HOW IT WORKS</p>
        <h2 className="how-it-works__title">Book your appointment in 3 steps</h2>
      </div>
      <div className="how-it-works__grid">
        {steps.map((step) => (
          <div className="how-it-works__card" key={step.number}>
            <div className="how-it-works__icon">{step.icon}</div>
            <div className="how-it-works__number">{step.number}</div>
            <h3 className="how-it-works__card-title">{step.title}</h3>
            <p className="how-it-works__card-text">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
